<div class="error container">
  <div class="error__content">
    <h1 data-cy="offer-not-found-message">Offer not found</h1>
  </div>
</div>
